var CalculatorService = /** @class */ (function () {
    function CalculatorService() {
    }
    CalculatorService.getInstance = function () {
        if (!CalculatorService.instance) {
            CalculatorService.instance = new CalculatorService();
        }
        return CalculatorService.instance;
    };
    // DETECT CALCULATOR
    CalculatorService.prototype.detect = function (form) {
        switch (form.id) {
            case 'calculator-how_much_can_i_borrow':
                this.doHL1(form);
                break;
            case 'calculator-how_much_will_i_pay_monthly':
                this.doHL2(form);
                break;
            case 'calculator-how_can_i_reduce_my_bond':
                this.doHL3(form);
                break;
            case 'calculator-personal_loans':
                this.doPL(form);
                break;
            case 'calculator-vaf_how_much_can_i_afford':
                this.doVAF1(form);
                break;
            case 'calculator-vaf_monthly_repayments':
                this.doVAF2(form);
                break;
            case 'calculator-vaf_finance_calculator':
                this.doVAF3(form);
                break;
            default:
                break;
        }
    };
    // CALCULATOR
    CalculatorService.prototype.doHL1 = function (form) {
        var total = 0;
        var gross = form.querySelectorAll('input[name=gross_monthly_income]');
        var expenses = form.querySelector('input[name=monthly_expenses]');
        var interest = form.querySelector('input[name=variable_interest_rate]');
        var term = form.querySelector('input[name=term]');
        var output_borrow = document.querySelectorAll('span.js-calculator-borrow-up-to-hl1');
        var estimate_repayment = document.querySelectorAll('span.js-calculator-estimated-repayment-hl1');
        [].slice.call(gross).forEach(function (input) {
            if (input.value) {
                total += parseFloat(input.value);
            }
        });
        var answer = this.HLHowMuchCanIBorrow(total, 0, expenses.value, term.value, interest.value);
        [].slice.call(output_borrow).forEach(function (div) {
            div.innerHTML = answer.loanAmounts;
        });
        [].slice.call(estimate_repayment).forEach(function (div) {
            div.innerHTML = answer.monthlyPayments;
        });
    };
    CalculatorService.prototype.doHL2 = function (form) {
        var purchaseprice = form.querySelector('input[name=purchase_price]');
        var deposit = form.querySelector('input[name=include_deposit]');
        var interest = form.querySelector('input[name=variable_interest_rate]');
        var term = form.querySelector('input[name=term]');
        var output_estimate = document.querySelectorAll('span.js-calculator-estimated-repayment-hl2');
        var output_period = document.querySelectorAll('span.js-calculator-loan-period-hl2');
        var answer = this.HLWhatWillIPayPerMonth(purchaseprice.value, deposit.value, term.value, interest.value);
        [].slice.call(output_estimate).forEach(function (div) {
            div.innerHTML = answer.monthlyRepayments;
        });
        [].slice.call(output_period).forEach(function (div) {
            div.innerHTML = answer.loanTerm;
        });
    };
    CalculatorService.prototype.doHL3 = function (form) {
        var bondbalance = form.querySelector('input[name=current_bond_balance]');
        var loanterm = form.querySelector('input[name=remaining_loan_term]');
        var interest = form.querySelector('input[name=variable_interest_rate]');
        var additional = form.querySelector('input[name=additional_recurring_payment]');
        var lumpsum = form.querySelector('input[name=once_off_lump_sum]');
        var reduceterm = form.querySelector('input[name=term_reduce]');
        var output_current_repayment = document.querySelectorAll('span.js-calculator-current-repayment-hl3');
        var output_estimated_repayment = document.querySelectorAll('span.js-calculator-estimated-repayment-hl3');
        var output_new_loanterm = document.querySelectorAll('span.js-calculator-new-loan-term-hl3');
        var output_interest_savings = document.querySelectorAll('span.js-calculator-interest-savings-hl3');
        var answer = this.HLHowCanIReduceMyBond(bondbalance.value, loanterm.value, interest.value, additional.value, lumpsum.value, reduceterm.value);
        [].slice.call(output_current_repayment).forEach(function (div) {
            div.innerHTML = answer.currentRepayment;
        });
        [].slice.call(output_estimated_repayment).forEach(function (div) {
            div.innerHTML = answer.estimatedRepayment;
        });
        [].slice.call(output_new_loanterm).forEach(function (div) {
            div.innerHTML = answer.newLoanTerm;
        });
        [].slice.call(output_interest_savings).forEach(function (div) {
            div.innerHTML = answer.interestSavings;
        });
    };
    CalculatorService.prototype.doPL = function (form) {
        var total = 0;
        var loanamount = form.querySelector('input[name=loan_amount]');
        total = parseFloat(loanamount.value);
        var interest = form.querySelector('input[name=variable_interest_rate]');
        var term = form.querySelector('input[name=term]');
        var output_borrow = document.querySelectorAll('span.js-calculator-estimated-repayment-pl1');
        var output_months = document.querySelectorAll('span.js-calculator-loan-period-pl1');
        var output_date = document.querySelectorAll('span.js-calculator-first-repayment-date-pl1');
        var output_fees = document.querySelectorAll('span.js-calculator-total-interest-pl1');
        var answer = this.PLMonthlyRepayments(total, interest.value, term.value);
        [].slice.call(output_borrow).forEach(function (div) {
            div.innerHTML = answer.estimatedMonthlyRepayment;
        });
        [].slice.call(output_date).forEach(function (div) {
            div.innerHTML = answer.date;
        });
        [].slice.call(output_fees).forEach(function (div) {
            div.innerHTML = answer.totalInterest;
        });
    };
    CalculatorService.prototype.doVAF1 = function (form) {
        var total = 0;
        var gross = form.querySelectorAll('input[name=gross_monthly_income]');
        var expenses = form.querySelector('input[name=monthly_expenses]');
        var output_available = document.querySelectorAll('span.js-calculator-available');
        [].slice.call(gross).forEach(function (input) {
            if (input.value) {
                total += parseFloat(input.value);
            }
        });
        var answer = this.VAFHowMuchCanIAfford(total, expenses.value);
        [].slice.call(output_available).forEach(function (div) {
            div.innerHTML = answer.availablePerMonth;
        });
    };
    CalculatorService.prototype.doVAF2 = function (form) {
        var purchaseprice = form.querySelector('input[name=purchase_price]');
        var deposit = form.querySelector('input[name=deposit]');
        var term = form.querySelector('select[name=term]');
        var balloon = form.querySelector('input[name=balloon]');
        var interest = form.querySelector('input[name=variable_interest_rate]');
        var output_loan = document.querySelectorAll('span.js-calculator-total-paid-vaf2');
        var output_estimate = document.querySelectorAll('span.js-calculator-estimated-repayment-vaf2');
        var answer = this.VAFMonthlyRepayments(purchaseprice.value, deposit.value, balloon.value, 0, term.value, interest.value);
        [].slice.call(output_loan).forEach(function (div) {
            div.innerHTML = answer.loanAmount;
        });
        [].slice.call(output_estimate).forEach(function (div) {
            div.innerHTML = answer.monthlyRepayment;
        });
    };
    CalculatorService.prototype.doVAF3 = function (form) {
        var preferredrepayment = form.querySelector('input[name=preferred_monthly_repayment]');
        var deposit = form.querySelector('input[name=deposit_2]');
        var term = form.querySelector('select[name=term_2]');
        var interest = form.querySelector('input[name=variable_interest_rate_2]');
        var output_amount = document.querySelectorAll('span.js-calculator-amount-i-can-spend-vaf3');
        var answer = this.VAFVehiclePurchasePrice(preferredrepayment.value, deposit.value, term.value, interest.value);
        [].slice.call(output_amount).forEach(function (div) {
            div.innerHTML = answer.amount;
        });
    };
    // PERSONAL LOANS
    CalculatorService.prototype.PLMonthlyRepayments = function (loanamount, loaninterest, loanterm) {
        if (loanamount === void 0) { loanamount = 0; }
        if (loaninterest === void 0) { loaninterest = 0; }
        if (loanterm === void 0) { loanterm = 10.25; }
        var initiationFee = Math.min(1050, 165 + 0.1 * (loanamount - 1000)) * 1.15;
        var serviceFee = 60 * 1.15;
        var normalValue = loanamount / loanterm;
        normalValue = this.round(normalValue, 2);
        var final = -this.pmt_vaf(loaninterest / 1200, loanterm, (loanamount + initiationFee), 0, 0) + serviceFee;
        final = this.round(final, 2);
        var interestTotal = this.round((final - normalValue), 2);
        var todaysDate = new Date();
        var getMonth = todaysDate.getMonth();
        todaysDate.setMonth(getMonth + 1, 1);
        var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        return {
            date: "1 " + monthNames[todaysDate.getMonth()] + " " + todaysDate.getFullYear(),
            iFee: initiationFee,
            sFee: serviceFee,
            totalInterest: this.formatter(interestTotal),
            estimatedMonthlyRepayment: this.formatter(final)
        };
    };
    // HOMELOANS
    CalculatorService.prototype.HLHowMuchCanIBorrow = function (gross, additional, expenses, term, interest, rir) {
        if (gross === void 0) { gross = 0; }
        if (additional === void 0) { additional = 0; }
        if (expenses === void 0) { expenses = 0; }
        if (term === void 0) { term = 0; }
        if (interest === void 0) { interest = 10.25; }
        if (rir === void 0) { rir = 0.30; }
        /* monthly payments */
        var amount = parseFloat(gross) + parseFloat(additional);
        var net = amount - parseFloat(expenses);
        var monthlyPaymentC = Math.min(net, (amount * rir));
        var monthlyPayment = this.formatter(monthlyPaymentC);
        /* loan amount */
        var interestRate = interest / 1200;
        var months = term * 12;
        var loanAmount = this.formatter(monthlyPaymentC * (1 - Math.pow(1 + interestRate, -months)) / interestRate);
        return {
            monthlyPayments: monthlyPayment,
            loanAmounts: loanAmount
        };
    };
    CalculatorService.prototype.HLWhatWillIPayPerMonth = function (purchase, deposit, term, interest) {
        if (purchase === void 0) { purchase = 0; }
        if (deposit === void 0) { deposit = 0; }
        if (term === void 0) { term = 0; }
        if (interest === void 0) { interest = 10.25; }
        var terms = term * 12;
        var inputPurchase = parseFloat(purchase);
        var inputDeposit = parseFloat(deposit);
        var inputInterest = parseFloat(interest);
        var inputTerm = parseFloat(terms);
        var monthlyRepayment = this.formatter(-this.round(this.pmt(inputInterest, 12, inputTerm, (inputPurchase - inputDeposit), 0), 0));
        return {
            monthlyRepayments: monthlyRepayment,
            loanTerm: terms + ' months'
        };
    };
    CalculatorService.prototype.HLHowCanIReduceMyBond = function (balance, remainingterm, interest, paymoreAdditonal, paymoreLumpsum, reduceTerm) {
        if (balance === void 0) { balance = 0; }
        if (remainingterm === void 0) { remainingterm = 0; }
        if (interest === void 0) { interest = 10.25; }
        if (paymoreAdditonal === void 0) { paymoreAdditonal = 0; }
        if (paymoreLumpsum === void 0) { paymoreLumpsum = 0; }
        if (reduceTerm === void 0) { reduceTerm = 0; }
        var currentPMT = 0;
        var currentPMTFormatted = 0;
        var estimatedPMTFormatted = 0;
        var newLoanTermFormatted = 0;
        var interestSavingsFormatted = 0;
        var lumpSumNewRepayment = 0;
        var lumpSumNewInterestSavings = 0;
        var nper = 0;
        // only additional added
        if (paymoreAdditonal > 0 && paymoreLumpsum == 0) {
            var valueWithoutAdditional = -this.pmt(interest, 12, remainingterm * 12, balance, 0);
            var valueWithAdditional = -this.pmt(interest, 12, remainingterm * 12, balance, 0) + parseFloat(paymoreAdditonal);
            nper = this.nper(interest, 12, valueWithAdditional, -(balance - paymoreLumpsum), 0);
            newLoanTermFormatted = Math.ceil(nper / 12);
            var valueSavingsAdditional1 = this.cumipmt(balance, interest, remainingterm * 12, valueWithoutAdditional);
            var valueSavingsAdditional2 = this.cumipmt(balance, interest, nper, valueWithAdditional);
            var valueSavingsAdditionalFinal = this.round(valueSavingsAdditional1 - valueSavingsAdditional2, 0);
            interestSavingsFormatted = this.formatter(valueSavingsAdditionalFinal);
            currentPMTFormatted = this.formatter(valueWithoutAdditional);
            estimatedPMTFormatted = this.formatter(valueWithAdditional);
        }
        else if (paymoreAdditonal > 0 && paymoreLumpsum > 0) {
            var valueWithoutAdditional = -this.pmt(interest, 12, remainingterm * 12, balance, 0);
            var valueWithAdditional = -this.pmt(interest, 12, remainingterm * 12, balance, 0) + parseFloat(paymoreAdditonal);
            nper = this.nper(interest, 12, valueWithAdditional, -(balance - paymoreLumpsum), 0);
            newLoanTermFormatted = Math.ceil(nper / 12);
            var valueSavingsAdditional1 = this.cumipmt(balance, interest, remainingterm * 12, valueWithoutAdditional);
            var valueSavingsAdditional2 = this.cumipmt(balance - paymoreLumpsum, interest, nper, valueWithAdditional);
            var valueSavingsAdditionalFinal = this.round(valueSavingsAdditional1 - valueSavingsAdditional2, 0);
            interestSavingsFormatted = this.formatter(valueSavingsAdditionalFinal);
            currentPMTFormatted = this.formatter(valueWithoutAdditional);
            estimatedPMTFormatted = this.formatter(valueWithAdditional);
        }
        else if (paymoreAdditonal == 0 && paymoreLumpsum > 0) {
            var totalAmount = balance - paymoreLumpsum;
            var valueWithAdditional = -this.pmt(interest, 12, remainingterm * 12, totalAmount, 0);
            var valueWithoutAdditional = -this.pmt(interest, 12, remainingterm * 12, balance, 0);
            nper = this.nper(interest, 12, valueWithoutAdditional, -totalAmount, 0);
            newLoanTermFormatted = Math.ceil(nper / 12);
            var valueSavingsOrigAdditional1 = this.cumipmt(balance, interest, remainingterm * 12, valueWithoutAdditional);
            var valueSavingsOrigAdditional2 = this.cumipmt(totalAmount, interest, nper, valueWithoutAdditional);
            var valueSavingsOrigAdditionalFinal = this.round(valueSavingsOrigAdditional1 - valueSavingsOrigAdditional2, 0);
            var valueSavingsAdditional1 = this.cumipmt2(interest / 1200, remainingterm, balance, 1, remainingterm, 0);
            var valueSavingsAdditional2 = this.cumipmt2(interest / 1200, remainingterm, totalAmount, 1, remainingterm, 0);
            var valueSavingsAdditionalFinal = this.round(valueSavingsAdditional1 - valueSavingsAdditional2, 0);
            interestSavingsFormatted = this.formatter(valueSavingsOrigAdditionalFinal);
            currentPMTFormatted = this.formatter(valueWithoutAdditional);
            estimatedPMTFormatted = this.formatter(valueWithAdditional);
            lumpSumNewRepayment = this.formatter(valueWithAdditional);
            lumpSumNewInterestSavings = this.formatter(valueSavingsAdditionalFinal);
        }
        else if (paymoreAdditonal == 0 && paymoreLumpsum == 0 && reduceTerm > 0) {
            var valueWithoutAdditional = -this.pmt(interest, 12, remainingterm * 12, balance, 0);
            var valueWithAdditional = -this.pmt(interest, 12, reduceTerm * 12, balance, 0);
            var valueSavingsAdditional1 = this.cumipmt2(interest / 1200, remainingterm * 12, balance, 1, remainingterm * 12, 0);
            var valueSavingsAdditional2 = this.cumipmt2(interest / 1200, reduceTerm * 12, balance, 1, reduceTerm * 12, 0);
            var valueSavingsAdditionalFinal = this.round(valueSavingsAdditional1 - valueSavingsAdditional2, 2);
            estimatedPMTFormatted = this.formatter(valueWithAdditional);
            newLoanTermFormatted = Math.ceil(reduceTerm * 12 / 12);
            currentPMTFormatted = this.formatter(valueWithoutAdditional);
            interestSavingsFormatted = this.formatter(valueSavingsAdditionalFinal);
        }
        else {
            currentPMT = Number(this.round(-this.pmt(interest, 12, remainingterm * 12, balance, 0), 0));
            currentPMTFormatted = this.formatter(currentPMT);
        }
        return {
            currentRepayment: currentPMTFormatted,
            estimatedRepayment: estimatedPMTFormatted,
            newLoanTerm: newLoanTermFormatted,
            interestSavings: interestSavingsFormatted,
            lumpSumNewMonthlyRepayment: lumpSumNewRepayment,
            lumpSumNewInterestSavings: lumpSumNewInterestSavings
        };
    };
    // VEHICLE AND ASSET FINANCE
    CalculatorService.prototype.VAFHowMuchCanIAfford = function (gross, expenses) {
        if (gross === void 0) { gross = 0; }
        if (expenses === void 0) { expenses = 0; }
        var amount = gross - expenses;
        return {
            availablePerMonth: this.formatter(amount)
        };
    };
    CalculatorService.prototype.VAFMonthlyRepayments = function (purchaseprice, deposit, baloonpercentage, baloonamount, loanterm, interest) {
        if (purchaseprice === void 0) { purchaseprice = 0; }
        if (deposit === void 0) { deposit = 0; }
        if (baloonpercentage === void 0) { baloonpercentage = 0; }
        if (baloonamount === void 0) { baloonamount = 0; }
        if (loanterm === void 0) { loanterm = 0; }
        if (interest === void 0) { interest = 10.25; }
        if (purchaseprice == 0) {
            return {
                monthlyRepayment: this.formatter(0),
                loanAmount: this.formatter(0)
            };
        }
        var monthlyRepayment = 0;
        var loanAmount = 0;
        var getLoan = 0;
        var getFinalLoan = 0;
        var getPayments = 0;
        var getDeposit = deposit;
        var getBalloonAmt = baloonamount;
        var getAmtAdminFee = 68.40;
        var i = interest;
        i = i / 100.0;
        i /= 12;
        var pow = 1;
        var j = 0;
        while (j < loanterm) {
            pow = pow * (1 + i);
            j++;
        }
        getLoan = purchaseprice - deposit;
        getBalloonAmt = baloonpercentage * purchaseprice / 100;
        getFinalLoan = (getLoan - getBalloonAmt / pow);
        getPayments = (getFinalLoan * pow * i) / (pow - 1);
        // monthlyRepayment = getPayments + getAmtAdminFee;
        monthlyRepayment = getPayments;
        loanAmount = (getPayments + getAmtAdminFee) * loanterm;
        if (baloonpercentage > 0) {
            loanAmount = getBalloonAmt + loanAmount;
        }
        return {
            monthlyRepayment: this.formatter(monthlyRepayment),
            loanAmount: this.formatter(loanAmount)
        };
    };
    CalculatorService.prototype.VAFVehiclePurchasePrice = function (preferredpayment, deposit, loanterm, interest) {
        if (preferredpayment === void 0) { preferredpayment = 0; }
        if (deposit === void 0) { deposit = 0; }
        if (loanterm === void 0) { loanterm = 0; }
        if (interest === void 0) { interest = 10.25; }
        var amount = 0;
        var depositString = deposit;
        var i = interest;
        i = i / 100.0;
        i /= 12;
        var j = 0;
        var pow = 1;
        while (j < loanterm) {
            pow = pow * (1 + i);
            j++;
        }
        amount = (preferredpayment * (1 - Math.pow(1 + i, -loanterm)) / i) + deposit;
        var amountFinal = parseFloat(amount) + parseFloat(depositString);
        return {
            amount: this.formatter(amountFinal)
        };
    };
    // RESET VALUES	- OUTPUTS
    CalculatorService.prototype.resetValues = function (form) {
        switch (form.id) {
            case 'calculator-how_much_can_i_borrow':
                var output_borrow_hl = document.querySelectorAll('span.js-calculator-borrow-up-to-hl1');
                var estimate_repayment_hl = document.querySelectorAll('span.js-calculator-estimated-repayment-hl1');
                [].slice.call(output_borrow_hl).forEach(function (div) {
                    div.innerHTML = '0';
                });
                [].slice.call(estimate_repayment_hl).forEach(function (div) {
                    div.innerHTML = '0';
                });
                break;
            case 'calculator-how_much_will_i_pay_monthly':
                var output_estimate_hl = document.querySelectorAll('span.js-calculator-estimated-repayment-hl2');
                var output_period_hl = document.querySelectorAll('span.js-calculator-loan-period-hl2');
                [].slice.call(output_estimate_hl).forEach(function (div) {
                    div.innerHTML = '0';
                });
                [].slice.call(output_period_hl).forEach(function (div) {
                    div.innerHTML = '0 months';
                });
                break;
            case 'calculator-how_can_i_reduce_my_bond':
                var output_current_repayment_hl = document.querySelectorAll('span.js-calculator-current-repayment-hl3');
                var output_estimated_repayment_hl = document.querySelectorAll('span.js-calculator-estimated-repayment-hl3');
                var output_new_loanterm_hl = document.querySelectorAll('span.js-calculator-new-loan-term-hl3');
                var output_interest_savings_hl = document.querySelectorAll('span.js-calculator-interest-savings-hl3');
                [].slice.call(output_current_repayment_hl).forEach(function (div) {
                    div.innerHTML = '0';
                });
                [].slice.call(output_estimated_repayment_hl).forEach(function (div) {
                    div.innerHTML = '0';
                });
                [].slice.call(output_new_loanterm_hl).forEach(function (div) {
                    div.innerHTML = '0';
                });
                [].slice.call(output_interest_savings_hl).forEach(function (div) {
                    div.innerHTML = '0';
                });
                break;
            case 'calculator-personal_loans':
                var output_borrow_pl = document.querySelectorAll('span.js-calculator-estimated-repayment-pl1');
                var output_months_pl = document.querySelectorAll('span.js-calculator-loan-period-pl1');
                [].slice.call(output_borrow_pl).forEach(function (div) {
                    div.innerHTML = '0';
                });
                [].slice.call(output_months_pl).forEach(function (div) {
                    div.innerHTML = '0 months';
                });
                break;
            case 'calculator-personal_loans_test':
                var output_borrow_plt = document.querySelectorAll('span.js-calculator-estimated-repayment-pl1');
                var output_months_plt = document.querySelectorAll('span.js-calculator-loan-period-pl1');
                [].slice.call(output_borrow_plt).forEach(function (div) {
                    div.innerHTML = '0';
                });
                [].slice.call(output_months_plt).forEach(function (div) {
                    div.innerHTML = '0 months';
                });
                break;
            case 'calculator-vaf_how_much_can_i_afford':
                var output_available_vaf = document.querySelectorAll('span.js-calculator-available');
                [].slice.call(output_available_vaf).forEach(function (div) {
                    div.innerHTML = '0';
                });
                break;
            case 'calculator-vaf_monthly_repayments':
                var output_loan_vaf = document.querySelectorAll('span.js-calculator-total-paid-vaf2');
                var output_estimate_vaf = document.querySelectorAll('span.js-calculator-estimated-repayment-vaf2');
                [].slice.call(output_loan_vaf).forEach(function (div) {
                    div.innerHTML = '0';
                });
                [].slice.call(output_estimate_vaf).forEach(function (div) {
                    div.innerHTML = '0';
                });
                break;
            case 'calculator-vaf_finance_calculator':
                var output_amount_vaf = document.querySelectorAll('span.js-calculator-amount-i-can-spend-vaf3');
                [].slice.call(output_amount_vaf).forEach(function (div) {
                    div.innerHTML = '0';
                });
                break;
            default:
                break;
        }
    };
    // FORMATTERS
    CalculatorService.prototype.formatter = function (value) {
        return parseFloat(value).toFixed(0).replace(/(\d)(?=(\d{3})+$)/g, '$1 ');
    };
    CalculatorService.prototype.noalpha = function (input) {
        input.value = input.value.replace(/[^0-9]/g, '');
    };
    CalculatorService.prototype.round = function (expr, decplaces) {
        var decpoint, str;
        str = '' + Math.round(expr * Math.pow(10, decplaces));
        while (str.length <= decplaces) {
            str = '0' + str;
        }
        decpoint = str.length - decplaces;
        return parseFloat(str.substring(0, decpoint) + '.' + str.substring(decpoint, str.length));
    };
    CalculatorService.prototype.pmt = function (rate, per, nper, pv, fv) {
        if (rate === void 0) { rate = 0; }
        if (per === void 0) { per = 0; }
        if (nper === void 0) { nper = 0; }
        if (pv === void 0) { pv = 0; }
        if (fv === void 0) { fv = 0; }
        var pmt_value, x;
        if ((per === 0) || (nper === 0)) {
            return 0;
        }
        rate = rate / (per * 100);
        if (rate === 0) {
            pmt_value = -(fv + pv) / nper;
        }
        else {
            x = Math.pow(1 + rate, nper);
            pmt_value = -((rate * (fv + x * pv)) / (-1 + x));
        }
        pmt_value = this.round(pmt_value, 2);
        return pmt_value;
    };
    CalculatorService.prototype.pmt_vaf = function (rate, period, value, futurevalue, type) {
        if (rate === void 0) { rate = 0; }
        if (period === void 0) { period = 0; }
        if (value === void 0) { value = 0; }
        if (futurevalue === void 0) { futurevalue = 0; }
        if (type === void 0) { type = 0; }
        if (!futurevalue)
            futurevalue = 0;
        if (!type)
            type = 0;
        if (rate == 0)
            return -(value + futurevalue) / period;
        var pvif = Math.pow(1 + rate, period);
        var pmt = rate / (pvif - 1) * -(value * pvif + futurevalue);
        if (type == 1) {
            pmt /= (1 + rate);
        }
        ;
        return pmt;
    };
    CalculatorService.prototype.nper = function (rate, per, pmt, pv, fv) {
        if (rate === void 0) { rate = 0; }
        if (per === void 0) { per = 0; }
        if (pmt === void 0) { pmt = 0; }
        if (pv === void 0) { pv = 0; }
        if (fv === void 0) { fv = 0; }
        var nper_value;
        if ((per === 0) || (pmt === 0)) {
            return 0;
        }
        rate = rate / (per * 100);
        if (rate === 0) {
            nper_value = -(fv + pv) / pmt;
        }
        else {
            nper_value = Math.log((-fv * rate + pmt) / (pmt + rate * pv)) / Math.log(1 + rate);
        }
        var end = this.round(nper_value, 2);
        return parseFloat(end);
    };
    CalculatorService.prototype.cumipmt = function (amount, rate, term, pmt) {
        if (amount === void 0) { amount = 0; }
        if (rate === void 0) { rate = 0; }
        if (term === void 0) { term = 0; }
        if (pmt === void 0) { pmt = 0; }
        var i, insertedAmount, interestSavings, k, ref, totalInterest, value1, value2, value3;
        totalInterest = 0;
        insertedAmount = amount;
        interestSavings = 0;
        for (i = k = 0, ref = term; 0 <= ref ? k < ref : k > ref; i = 0 <= ref ? ++k : --k) {
            value1 = insertedAmount * (rate / 1200);
            value2 = pmt - value1;
            value3 = insertedAmount - value2;
            insertedAmount = value3;
            interestSavings = interestSavings + value1;
        }
        return interestSavings;
    };
    CalculatorService.prototype.cumipmt2 = function (rate, periods, value, start, end, type) {
        if (rate === void 0) { rate = 0; }
        if (periods === void 0) { periods = 0; }
        if (value === void 0) { value = 0; }
        if (start === void 0) { start = 0; }
        if (end === void 0) { end = 0; }
        if (type === void 0) { type = 0; }
        var i, interest, payment;
        payment = this.pmt_cumipmt(rate, periods, value, 0, type);
        interest = 0;
        if (start === 1) {
            if (type === 0) {
                interest = -value;
                start++;
            }
        }
        i = start;
        while (i <= end) {
            if (type === 1) {
                interest += this.fv(rate, i - 2, payment, value, 1) - payment;
            }
            else {
                interest += this.fv(rate, i - 1, payment, value, 0);
            }
            i++;
        }
        interest *= rate;
        return -interest;
    };
    CalculatorService.prototype.fv = function (rate, periods, payment, value, type) {
        if (rate === void 0) { rate = 0; }
        if (periods === void 0) { periods = 0; }
        if (payment === void 0) { payment = 0; }
        if (value === void 0) { value = 0; }
        if (type === void 0) { type = 0; }
        var result, term;
        value = value || 0;
        type = type || 0;
        result = void 0;
        if (rate === 0) {
            result = value + payment * periods;
        }
        else {
            term = Math.pow(1 + rate, periods);
            if (type === 1) {
                result = value * term + payment * (1 + rate) * (term - 1) / rate;
            }
            else {
                result = value * term + payment * (term - 1) / rate;
            }
        }
        return -result;
    };
    CalculatorService.prototype.pmt_cumipmt = function (rate, periods, present, future, type) {
        if (rate === void 0) { rate = 0; }
        if (periods === void 0) { periods = 0; }
        if (present === void 0) { present = 0; }
        if (future === void 0) { future = 0; }
        if (type === void 0) { type = 0; }
        var result, term;
        future = future || 0;
        type = type || 0;
        result = void 0;
        if (rate === 0) {
            result = (present + future) / periods;
        }
        else {
            term = Math.pow(1 + rate, periods);
            if (type === 1) {
                result = (future * rate / (term - 1) + present * rate / (1 - (1 / term))) / (1 + rate);
            }
            else {
                result = future * rate / (term - 1) + present * rate / (1 - (1 / term));
            }
        }
        return -result;
    };
    // SIMPLE INTEREST
    CalculatorService.prototype.simpleInterest = function (deposit, term, interest) {
        if (deposit === void 0) { deposit = 0; }
        if (term === void 0) { term = 0; }
        if (interest === void 0) { interest = 10.25; }
        var result = 0;
        var _interest = (interest / 100);
        var _years = (term / 12);
        result = deposit * (1 + (_interest * _years));
        return {
            amount: this.formatter(result),
        };
    };
    // COMPOUND INTEREST
    CalculatorService.prototype.compoundInterest = function (deposit, monthlyDeposit, term, interest) {
        if (deposit === void 0) { deposit = 0; }
        if (monthlyDeposit === void 0) { monthlyDeposit = 0; }
        if (term === void 0) { term = 0; }
        if (interest === void 0) { interest = 10.25; }
        var _deposit = parseFloat(deposit);
        var _monthlyDeposit = parseFloat(monthlyDeposit);
        var _term = parseFloat(term);
        var _interest = parseFloat(interest);
        var _intRate = this.round((Math.pow(1 + _interest / 100, 1 / 12) - 1), 3);
        var result = 0;
        for (var a = 0; a < _term; a++) {
            var _int = 0;
            if (a == 0) {
                _int = (_deposit * _intRate);
                result = _deposit;
            }
            else {
                _int = ((result * _intRate) + _monthlyDeposit);
            }
            _int = this.round(_int, 2);
            result = this.round((result + _int), 2);
        }
        return {
            amount: this.formatter(result),
        };
    };
    return CalculatorService;
}());
export { CalculatorService };



//////////////////
// WEBPACK FOOTER
// ./services/calculator.service.ts
// module id = 62
// module chunks = 0